// Components==============
import React, { useContext } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Button from 'components/UI/Button/Button';
import { ReflectContext } from '../../Reflect';
// =========================

export default function ToggleAllButton() {
  const translate = useTranslate();
  const { toggled, onClickToggle } = useContext(ReflectContext);

  return (
    <>
      <Button onClick={onClickToggle} color={toggled ? 'white' : 'blue'}>
        {toggled
          ? translate('project.actions.close-all')
          : translate('project.actions.open-all')}
      </Button>
    </>
  );
}
